import React from 'react';

import {
    Footer,
    Meta,
} from '$partials/global/index.js';
import { Button } from '$partials/ui';
import ModuleDispatcher from '$partials/modules/dispatcher.jsx';
import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').FaqPage}
 */

const FaqPage = ({ data, domain }) => {

    const page = data?.page;
    const {
        formatURI,
        translate: t,
    } = useLocale();

    if (!page) { return null; }
    return (
        <>
            <Meta page={page} />

            <main id='main-content'>
                <div className='min-h-screen'>
                    <section className='layout-container layout-site-outer-padding flex flex-col pb-24 pt-[116px] sm:pt-[108px] md:pt-[160px]'>
                        <h1 className='type-style-3-extended text-text-primary'>
                            {page?.pageTitle}
                        </h1>

                        {/* body copy */}
                        {page?.bodyCopy && (
                            <p className='text-text-secondary type-style-body mt-10 md:mt-16 sm:w-10/12 md:w-6/12'>
                                {page.bodyCopy}
                            </p>
                        )}

                        {/* cta buttons */}
                        {(page?.cta1Link || page?.cta2Link) && (
                            <div className='flex flex-wrap gap-8 mt-24 md:mt-32'>
                                {page?.cta1Link && (
                                    <Button
                                        as='a'
                                        className='button button--primary'
                                        href={formatURI(page.cta1Link)}>
                                        <span className='button__label--animate'>
                                            <span>{page.cta1Label}</span>
                                        </span>
                                    </Button>
                                )}
                                {page?.cta2Link && (
                                    <Button
                                        as='a'
                                        className='button button--secondary'
                                        href={formatURI(page.cta2Link)}>
                                        <span className='button__label--animate'>
                                            <span>{page.cta2Label}</span>
                                        </span>
                                    </Button>
                                )}
                            </div>
                        )}
                    </section>

                    {/* Content */}
                    {(page?.modules?.items?.length > 0) && (
                        page.modules.items.map((module, i) => {
                            if (!module) { return null; }
                            return (
                                <ModuleDispatcher
                                    key={i}
                                    module={module}
                                    previousTypename={page.modules.items[i - 1]?.__typename ?? null}
                                    nextTypename={page.modules.items[i + 1]?.__typename ?? null}/>
                            );
                        })
                    )}

                    <div className='pt-8'>
                        <Footer
                            domain={domain}
                            menu={data?.footer} />
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default FaqPage;
